import { createSlice } from "@reduxjs/toolkit";

const initialFilters = {
  status: null,
  assignee: null,
  // ISO yyyy-mm-dd strings from the date inputs. Null means "no bound on that
  // side", so a single value yields a one-sided range.
  dateFrom: null,
  dateTo: null,
};

export const pqrsdSlice = createSlice({
  name: "pqrsd",
  initialState: {
    list: [],
    loading: false,
    filters: initialFilters,
    current: null,
  },
  reducers: {
    setPqrsdLoading: (state, action) => {
      state.loading = !!action.payload;
    },
    setPqrsdList: (state, action) => {
      state.list = action.payload || [];
      state.loading = false;
    },
    appendPqrsdList: (state, action) => {
      const incoming = action.payload || [];
      if (!incoming.length) return;
      const seen = new Set(state.list.map((p) => p.filedId));
      for (const item of incoming) {
        if (!seen.has(item.filedId)) {
          state.list.push(item);
          seen.add(item.filedId);
        }
      }
    },
    setPqrsdFilters: (state, action) => {
      state.filters = { ...state.filters, ...(action.payload || {}) };
    },
    resetPqrsdFilters: (state) => {
      state.filters = initialFilters;
    },
    setCurrentPqrsd: (state, action) => {
      state.current = action.payload || null;
    },
  },
});

export const {
  setPqrsdLoading,
  setPqrsdList,
  appendPqrsdList,
  setPqrsdFilters,
  resetPqrsdFilters,
  setCurrentPqrsd,
} = pqrsdSlice.actions;

export default pqrsdSlice.reducer;
